import { useState } from "react";

import { EnvelopeIcon } from "@heroicons/react/24/outline";
import Form from "V2.0/components/Form";
import Joi from "joi-browser";
import { message } from "antd";
import {
  sheetURLFieldTemplate,
  sheetURLFieldSchema,
} from "V2.0/HomePages/HomeCampaign/bulkUpload/fields/sheetURLField";
import { triggerTypeField } from "../../common/fields";

export default function BulkSmsCampaignForm(props) {
  const {
    createBulkCampaign,
    onClose,
    assistantId,
    fromNumber,
    name,
    description,
    loading,
    setLoading,
    ignorePreviousCampaigns
  } = props;

  const inputField = {
    name,
    description,
    sheetURL: "",
    fromNumber,
    triggerType: "",
    message: "",
    campaignType: "sms",
    assistantId,
    ignorePreviousCampaigns
  };

  const [errorMessage] = useState({});

  const template = [
    sheetURLFieldTemplate,
    triggerTypeField,
    {
      name: "message",
      label: "Message *",
      description: "The message to be sent to your contact",
      type: "textArea",
      style: { height: "100px" },
    },
  ];

  const schema = {
    ...sheetURLFieldSchema,
    name: Joi.string().required().label("Campaign Name"),
    description: Joi.string().allow(null, "").label("Campaign Description"),
    message: Joi.string().required().max(160).label("message"),
    fromNumber: Joi.string()
      .regex(/^\+?[0-9]+$/)
      .required()
      .label("From Number"),
    triggerType: Joi.string().required().label("Trigger Type"),
    campaignType: Joi.string().required().label("Campaign Type"),
    assistantId: Joi.string().required(),
    ignorePreviousCampaigns: Joi.boolean()
  };

  const handleSubmit = (data) => {
    createBulkCampaign(data);
  };

  return (
    <Form
      key={JSON.stringify(inputField)}
      errorMessage={errorMessage}
      inputField={inputField}
      template={template}
      schema={schema}
      buttonInfo={{
        style: "",
        buttons: "2",
        // primaryLabel: "Start", // plain string label — replaced with icon+text matching the
        // channel, per Frontend's pattern (bulk-campaign-report-ui-port, Task 7)
        primaryLabel: (
          <>
            <EnvelopeIcon className="size-4" />
            Start SMS Campaign
          </>
        ),
        secondaryLabel: "Close",
      }}
      onSubmit={handleSubmit}
      loading={loading}
      setLoading={setLoading}
      handleSecondary={onClose}
    />
  );
}
